type Props = {
    text: string;
};

export const TabTitleBar: React.FC<Props> = ({ text }) => {
    return (
        <div className="flex h-[30px] items-center justify-center rounded bg-grey-table-hover">
            <p className="text-center text-sm font-medium text-midnight">{text}</p>
        </div>
    );
};
